import styled, { css } from 'styled-components';
import { getTypographyFromTheme, themeColor } from '../../utils';
export const defaultTypographyStyles = {
    em: css `
    font-style: italic;
  `,
};
const getProperty = (obj, key) => obj[key];
export default styled.p `
  ${({ as, forwardedAs }) => getProperty(defaultTypographyStyles, as || forwardedAs)};
  margin: 0;
  ${getTypographyFromTheme()};
  font-stretch: normal;
  letter-spacing: normal;
  ${({ strong }) => strong &&
    css `
      font-weight: 700;
      color: ${themeColor('tint', 'level7')};
    `}
  ${({ color }) => color &&
    css `
      color: ${themeColor(color)};
    `}
  ${({ fontSize }) => fontSize &&
    css `
      font-size: ${fontSize}px;
    `}
`;
//# sourceMappingURL=TypographyStyle.js.map